module.exports = __webpack_public_path__ + "img/104.5144e945.png";